<template>
  <div class="project-introduction">
    <img src="@/assets/projectIntroductionImg.png" class="projectIntroductionImg" alt="">
  </div>
</template>

<script>
export default {
  name: 'ProjectIntroduction',
  data() {
    return {
      // 页面数据
    }
  },
  methods: {
    // 页面方法
  }
}
</script>

<style lang="scss" scoped>
.projectIntroductionImg{
  width: 100%;
  height: 100%;
}
</style>
